module.exports = __webpack_public_path__ + "static/media/thumbnail.fe859128.jpg";